import React from 'react';
import { useSelector } from 'react-redux';
import { Checkbox, Input } from '../../../../index.js';
import { Row, Col } from '../../../../Grid/index.js';
const Interest = (props) => {
    const lang = useSelector((s) => s.lang);
    return (React.createElement(Row, null,
        React.createElement(Col, { width: "12" },
            React.createElement("h3", null, "Rubrik 4"),
            React.createElement(Row, null,
                React.createElement(Col, { width: "6" },
                    React.createElement(Checkbox, { style: { display: 'inline-block' }, placeholder: lang.documents.interestFromSubmitOfBPK, checked: props.interestFromSubmitOfBPK, onChange: (e) => {
                            props.setDocumentState({
                                interestFromSubmitOfBPK: e.target.checked,
                            });
                        } }),
                    !props.interestFromSubmitOfBPK && (React.createElement(Input, { placeholder: lang.documents.interestDates, value: props.interestDates, onChange: (e) => {
                            props.setDocumentState({
                                interestDates: e.target.value,
                            });
                        } })),
                    React.createElement(Input, { placeholder: lang.documents.totalAmount, value: props.totalAmount, onChange: (e) => {
                            props.setDocumentState({
                                totalAmount: e.target.value,
                            });
                        } })),
                React.createElement(Col, { width: "6" },
                    React.createElement(Input, { placeholder: lang.documents.interestAmount, value: props.interests, onChange: (e) => {
                            props.setDocumentState({
                                interests: e.target.value,
                            });
                        } })),
                React.createElement(Col, { width: "6" },
                    React.createElement(Checkbox, { style: { display: 'inline-block' }, placeholder: lang.documents.procesinterest, checked: props.processInterest, onChange: (e) => {
                            props.setDocumentState({
                                processInterest: e.target.checked,
                            });
                        } }),
                    !props.processInterest && (React.createElement(Input, { placeholder: lang.documents.caseinterest, value: props.caseInterest, onChange: (e) => {
                            props.setDocumentState({
                                caseInterest: e.target.value,
                            });
                        } })))))));
};
export default Interest;
//# sourceMappingURL=Interest.js.map